const BYCE_STATEMENT_KEY = "byce.listening-conditions.headphones-quiet-en";

const statements = {
  "byce.g3.listening-conditions.headphones-earphones-quiet-en@student-text-11.1": {
    acknowledgement: "I am using headphones or earphones in a quiet environment.",
    reminder: "Your listening setup is part of the rating. A voice rated in a noisy room is not comparable to the same voice rated in a quiet one.",
  },
  [`${BYCE_STATEMENT_KEY}@structural-review-1`]: {
    acknowledgement: "I am using headphones or earphones and am in a quiet environment.",
    reminder: "Use headphones or earphones and work in a quiet environment.",
  },
  [`${BYCE_STATEMENT_KEY}@structural-review-2`]: {
    acknowledgement: "I am using headphones or earphones, or I am listening in a quiet environment.",
    reminder: "Use headphones or earphones, or listen in a quiet environment.",
  },
};

export function listeningConditionStatementPresentation(requirement = {}) {
  return statements[`${requirement.statementKey}@${requirement.statementVersion}`] || {
    acknowledgement: "I acknowledge the configured listening conditions.",
    reminder: "Continue under the listening conditions you acknowledged.",
  };
}
